import React from 'react'
import { get } from 'lodash'
import { ReactTable, vehicleStatsByCompany } from '../../feature-react-table'
import { useSearchVehiclesByAccountDetailLazyQuery } from '../generated/graphql'
import type { SearchCardDetailProps } from '../types'

const {
    accessors: { accountName, avgSaleAmount, conversion, ran, sold, sumSaleAmount, total },
    Cells: { Account },
} = vehicleStatsByCompany

const desktopColumns = [
    {
        Header: 'Account (Seller)',
        accessor: accountName,
        Cell: Account,
        width: 36,
    },
    {
        Header: 'Total',
        accessor: total,
        width: 8,
    },
    {
        Header: 'Sales',
        accessor: sold,
        width: 8,
    },
    {
        Header: 'Amount',
        accessor: sumSaleAmount,
        width: 15,
    },
    {
        Header: 'Avg Sale',
        accessor: avgSaleAmount,
        width: 15,
    },
    {
        Header: 'Ran',
        accessor: ran,
        width: 8,
    },
    {
        Header: 'Conversion',
        accessor: conversion,
        width: 15,
    },
]

const mobileColumns = [
    {
        Header: 'Account (Seller)',
        accessor: accountName,
        Cell: Account,
    },
    {
        Header: 'Sales',
        accessor: sold,
    },
    {
        Header: 'Ran',
        accessor: ran,
    },
    {
        Header: 'Conversion',
        accessor: conversion,
    },
]

export const SearchVehiclesByAccountDetailComponent: React.VFC<SearchCardDetailProps> = ({
    searchString,
    title,
}: SearchCardDetailProps) => {
    return (
        <ReactTable
            shareMetaData={{ shareSubject: 'Sellers' }}
            columns={desktopColumns}
            mobileColumns={mobileColumns}
            listPath="auction.search.vehicleStatsByCompany"
            countPath="auction.search.accountCount"
            lazyQueryHook={useSearchVehiclesByAccountDetailLazyQuery}
            queryOptions={{ variables: { searchString } }}
            paginated
            title={({ res }): string => title || get(res, 'auction.search.searchStringDisplay', 'Search Results')}
        />
    )
}
